export default __webpack_public_path__ + "static/media/logo.c8aaaf89.png";